import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useRowSelect } from 'react-table/dist/react-table.development'
import { useTable } from 'react-table'
import { Center, Text, VStack } from '@chakra-ui/react'
import CustomCell from './TableCells/CustomCell/CustomCell'
import { selectableColumn } from './customColumns'
import TableUI from './TableUI'
import SvgIcon, { iconNames } from '../SvgIcon/SvgIcon'

const defaultColumn = {
  Cell: CustomCell,
}

const Table = ({
  orderBy,
  orderAsc,
  onDeclineRefill,
  columns = [],
  data = [],
  updateMyData = () => null,
  isSelectable = false,
  validateSelectable = () => true,
  handleSelected = () => null,
  onEmployeeClick = () => null,
  onRefillStatusClick = () => null,
  withPagination,
  paginationProps,
  onSort = () => null,
}) => {
  const { selectedFlatRows, ...tableHooksProps } = useTable(
    {
      columns,
      data,
      defaultColumn,
      updateMyData,
      onEmployeeClick,
      onRefillStatusClick,
      onDeclineRefill,
    },
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((items) => [selectableColumn, ...items])
    },
  )
  const tableProps = useMemo(
    () => ({
      isSelectable,
      ...tableHooksProps,
      withPagination,
    }),
    [isSelectable, tableHooksProps, withPagination],
  )

  useEffect(() => {
    if (isSelectable) {
      handleSelected(selectedFlatRows)
    }
  }, [selectedFlatRows, handleSelected])

  return (
    <VStack w="100%" spacing={0}>
      <TableUI
        validateSelectable={validateSelectable}
        onSort={onSort}
        paginationProps={paginationProps}
        {...{ orderBy, orderAsc }}
        {...tableProps}
      />
      {!data.length && (
        <Center border="1px solid rgb(215, 215, 215)" w="100%" h="300px">
          <VStack>
            <SvgIcon iconName={iconNames.noDataTable} />
            <Text>No existen registros.</Text>
          </VStack>
        </Center>
      )}
    </VStack>
  )
}

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  handleSelected: PropTypes.func,
  isSelectable: PropTypes.bool,
  onDeclineRefill: PropTypes.func,
  onEmployeeClick: PropTypes.func,
  onRefillStatusClick: PropTypes.func,
  onSort: PropTypes.func,
  orderAsc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  orderBy: PropTypes.string,
  paginationProps: PropTypes.object,
  updateMyData: PropTypes.func,
  validateSelectable: PropTypes.func,
  withPagination: PropTypes.bool,
}

export default Table
